var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368:5568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.19853 0C1.43611 0 0.000921765 1.43723 0 3.20308C0 4.96985 1.43519 6.40615 3.19853 6.40615C4.96186 6.40615 6.39613 4.96892 6.39613 3.20308C6.39613 1.43723 4.96186 0 3.19853 0Z",
    fill: "#68717A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59957 7.69373H0.797173C0.568576 7.69373 0.383301 7.87926 0.383301 8.10819V23.5863C0.383301 23.8153 0.568576 24.0008 0.797173 24.0008H5.59865C5.82725 24.0008 6.01252 23.8153 6.01252 23.5863V8.10819C6.01344 7.87926 5.82817 7.69373 5.59957 7.69373Z",
    fill: "#68717A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8749 7.51123C16.118 7.51123 14.5731 8.04754 13.6311 8.92077V8.10754C13.6311 7.87861 13.4458 7.69308 13.2172 7.69308H8.61114C8.38254 7.69308 8.19727 7.87861 8.19727 8.10754V23.5857C8.19727 23.8146 8.38254 24.0002 8.61114 24.0002H13.408C13.6366 24.0002 13.8219 23.8146 13.8219 23.5857V15.9278C13.8219 13.7309 14.2256 12.3694 16.2397 12.3694C18.2242 12.3722 18.3726 13.8325 18.3726 16.0598V23.5866C18.3726 23.8155 18.5579 24.0011 18.7865 24.0011H23.5862C23.8147 24.0011 24 23.8155 24 23.5866V15.0962C24 11.5645 23.3032 7.51123 17.8749 7.51123Z",
    fill: "#68717A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368:5568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/LN.5158d35c.svg";
export { ForwardRef as ReactComponent };